import React from "react";
import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";

function Kbd({ combo, label }) {
  return (
    <span className="sc">
      <span className="keycap-group">
        {combo.split("+").map((k, i) => (
          <kbd className="keycap" key={i}>
            {k}
          </kbd>
        ))}
      </span>
      {label}
    </span>
  );
}

export default function Home({ entries }) {
  const features = [
    {
      title: "Formatters",
      description:
        "Pretty-print, minify, and lint JSON, XML, YAML, HTML, CSS and JS — with fine-grained control over indent, sort, and quote style.",
      link: "/formatter/json",
    },
    {
      title: "Converters",
      description:
        "Translate between formats with predictable output. Generate Go structs from JSON, or convert JSON ↔ XML ↔ YAML in one keystroke.",
      link: "/converter/json-to-xml",
    },
  ];

  return (
    <AppLayout entries={entries} showRightSidebar={false}>
      <div className="home">
        <div className="home-grid" aria-hidden="true" />
        <section className="intro">
          <h1>{`Welcome to <${window.SITE_NAME}/>`}</h1>
          <p>
            A quiet, keyboard-first workspace for formatting and converting
            code &amp; data. No tabs to lose, no sign-up, no telemetry — just
            your buffer and a sharp pair of editors.
          </p>

          <div className="hero-actions">
            <Link to="/formatter/json" className="btn btn-primary">
              Open workspace →
            </Link>
            <Link to="/about" className="btn">
              Read the docs
            </Link>
          </div>

          <div className="hero-shortcuts">
            <Kbd combo="⌘+I" label="theme" />
            <Kbd combo="⌘+B" label="options" />
            <Kbd combo="⌘+L" label="struct view" />
          </div>
        </section>

        <section className="cards">
          {features.map((feature) => (
            <Link key={feature.title} to={feature.link} className="card">
              <h2>{feature.title}</h2>
              <p>{feature.description}</p>
              <span className="cta">→ Open {feature.title}</span>
            </Link>
          ))}
        </section>
      </div>
    </AppLayout>
  );
}
